"use client";

import { Bug } from "@layer/icons";
import { Button } from "@layer/ui/components";
import { LogLevel } from "@layer/utils/lib/logger";
import { CustomError } from "@layer/utils/server-actions";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

// TODO: Need to think about how Localisation will work for ERROR Logging
export default function AppError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const t = useTranslations("Errors");

	useEffect(() => {
		if (error) {
			CustomError({
				source: "Application Root",
				operation: "Error Handler",
				message: error.message,
				logLevel: LogLevel.ERROR,
			});
		}
	}, [error]);

	return (
		<div className="h-layout bg-neutral relative w-full items-center justify-center bg-[linear-gradient(to_right,var(--gray-3)_1px,transparent_1px),linear-gradient(to_bottom,var(--gray-3)_1px,transparent_1px)] bg-[size:6rem_4rem]">
			<div className="flex h-full w-full flex-col items-center justify-center py-4 text-center">
				<article className="bg-neutral-base w-full max-w-md rounded-md border p-6 text-left">
					<Bug
						variant="mono"
						className="fill-danger-solid h-8 w-8 rounded-full border p-1"
					/>
					<h2 className="text-neutral-text-contrast my-2 text-lg">
						{t("titles.unexpectedError")}
					</h2>
					<p className="border-danger-border text-danger-text my-2 min-h-36 rounded-md border border-dotted p-2 text-left font-mono text-sm">
						{" "}
						{error.message || t("unexpectedError")}
					</p>
					<div className="flex gap-x-2">
						<Button variant="outline" onClick={reset}>
							{t("tryAgain")}
						</Button>
						<Button variant="outline" onClick={reset}>
							{t("contactSupport")}
						</Button>
					</div>
				</article>
			</div>
		</div>
	);
}
